import { nanoid } from 'nanoid';

const addKeyToChildren = (list, childrenProp) => {
  if (Array.isArray(list) && list?.length) {
    list.forEach((i) => {
      if (Array.isArray(i[childrenProp])) {
        i[childrenProp].forEach((i) => (i.key = nanoid()));
      }
    });
  }
};

export const addKeyToHeadcountSalesData = (data = {}) => {
  if (data) {
    [
      'buyerHeadcountAndSalesData',
      'targetHeadcountAndSalesData',
      'newTerritoriesData',
    ].forEach((type) => {
      addKeyToChildren(data[type]?.headcountData, 'companyHeadcountList');
      addKeyToChildren(data[type]?.salesData, 'companySalesList');
    });
  }
  return data || {};
};
